/* nr10-analytics.js — GA4 soft-conversion events (2026-07).
 *
 * Sends custom events through the page-level gtag stub (theme.liquid). The GA4
 * destination G-Y4M4QNFQE7 is configured by the Google & YouTube channel web pixel,
 * which shares this window/dataLayer — so every event must carry an explicit
 * send_to. The theme must NOT config G-Y4M4QNFQE7 itself (see theme.liquid: a
 * duplicate config inflated sessions ~2.1x from 2026-07-17). Page views + ecommerce
 * come from the channel integration — nothing here may send page_view or purchase.
 *
 * Events:
 *   email_signup        { placement: 'footer' | 'popup' | 'attentive_popup' }
 *   sms_signup          { placement: 'attentive_popup' }
 *   club_signup_start   { tier }        — Bloom tier "Join" click on /pages/the-social-club
 *   club_signup_complete{ tier }        — Bloom join modal reaches its success step
 *   blog_cta_click      { destination, placement: 'body_cta' | 'theme_cta' } — /blogs/* pages
 *
 * account_created is NOT here — it's a GA4 event-create rule on native page_views.
 */
(function () {
  'use strict';

  function track(name, params) {
    if (typeof window.gtag !== 'function') return;
    var p = params || {};
    // Route to the GA4 destination configured by the channel web pixel. Without this,
    // the event would only reach the theme's own container (AW-832076959).
    p.send_to = 'G-Y4M4QNFQE7';
    // GA4 DebugView: append ?nr10debug=1 to any URL while testing
    if (/[?&]nr10debug=1/.test(location.search)) p.debug_mode = true;
    window.gtag('event', name, p);
  }
  window.nr10Track = track; // used by the footer newsletter form (footer-base44.liquid)

  /* ---- email_signup (popup): Klaviyo onsite forms emit `klaviyoForms` ---- */
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail && e.detail.type === 'submit') {
      track('email_signup', { placement: 'popup' });
    }
  });

  /* ---- Attentive sign-up unit: its creative iframe (creatives.attn.tv)
     posts {__attentive:{action}} to the page. EMAIL_LEAD = email step
     submitted, LEAD = phone/SMS step submitted (verified live 2026-07-17).
     Fires at submit time, same semantic as the other signup forms. ---- */
  var attnFired = {};
  window.addEventListener('message', function (e) {
    if (!/^https:\/\/[a-z0-9.-]+\.attn\.tv$/i.test(e.origin)) return;
    var d = e.data && e.data.__attentive;
    if (!d || !d.action || attnFired[d.action]) return;
    if (d.action === 'EMAIL_LEAD') {
      attnFired[d.action] = true;
      track('email_signup', { placement: 'attentive_popup' });
    } else if (d.action === 'LEAD') {
      attnFired[d.action] = true;
      track('sms_signup', { placement: 'attentive_popup' });
    }
  });

  /* ---- club_signup_start: Bloom join-form tier buttons live in an open
     shadow root; user clicks are composed and cross it. ---- */
  var clubTier = '';
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var inJoinForm = false;
    var btn = null;
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || !el.tagName) continue;
      if (!btn && el.tagName === 'BUTTON' && /^join$/i.test((el.textContent || '').trim())) btn = el;
      if (el.id === 'bloom-join-form') inJoinForm = true;
    }
    if (!btn || !inJoinForm) return;
    // innermost container that has its own tier heading = the tier card
    for (var j = 0; j < path.length; j++) {
      var card = path[j];
      if (card && card.querySelector) {
        var h = card.querySelector('h1,h2,h3,h4');
        if (h) { clubTier = (h.textContent || '').trim(); break; }
      }
    }
    track('club_signup_start', { tier: clubTier || '(unknown)' });
    watchForClubSuccess();
  }, true);

  /* ---- club_signup_complete: the join modal's final step renders
     bloom_joinFormSuccessStep inside the #bloomModalAnchor shadow root.
     (Bloom bundles its own fetch via cross-fetch, so a fetch wrapper
     cannot see the membershipCreate call — watch the DOM instead.) ---- */
  var clubObserver = null;
  var clubCompleted = false;
  function watchForClubSuccess() {
    if (clubObserver || clubCompleted) return;
    var anchor = document.getElementById('bloomModalAnchor');
    var root = anchor && anchor.shadowRoot;
    if (!root) return;
    clubObserver = new MutationObserver(function () {
      if (clubCompleted) return;
      if (root.querySelector('[class*="joinFormSuccessStep"]')) {
        clubCompleted = true;
        clubObserver.disconnect();
        track('club_signup_complete', { tier: clubTier || '(unknown)' });
      }
    });
    clubObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* ---- blog_cta_click: collection/product links inside learn articles ---- */
  if (location.pathname.indexOf('/blogs/') === 0) {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!/^\/(collections|products)\//.test(href)) return;
      var placement = a.closest('.b44-article__cta-wrap') ? 'theme_cta'
                    : a.closest('article') ? 'body_cta' : null;
      if (!placement) return; // header/footer nav links
      track('blog_cta_click', { destination: href, placement: placement });
    }, true);
  }
})();
